<template>
  <b-modal id="two-factor-code-input-modal"
           :title="$t('two_factor_authorization')"
           centered
           size="sm"
           @shown="onShow"
           @hidden="emit('hide')"
           hide-footer>
    <div class="text-center">
      <div class="mb-4">{{ mode === 'backup' ? $t('enter_backup_code_note') : $t('enter_code_from_authorization_app') }}</div>
      <InputGroup :label="mode === 'backup' ? $t('backup_code') : $t('code')"
                  :autofocus="true"
                  :showErrors="true"
                  validation-id="code"
                  class="text-center"
                  ref="codeInput"
                  @input="codeInputHandler"/>
      <div v-if="allowForBackup" class="small">
        <a v-if="mode === 'code'"
           class="pointer text-underlined"
           @click="mode = 'backup'">
          {{ $t('use_backup_code') }}
        </a>
        <a v-if="mode === 'backup'"
           class="pointer text-underlined"
           @click="mode = 'code'">
          {{ $t('use_app_code') }}
        </a>
      </div>
    </div>
  </b-modal>
</template>

<script setup>
import {getCurrentInstance, onMounted, ref} from "vue"
import InputGroup from "@/components/form/InputGroup.vue"
import {useStore} from "vuex"

const emit = defineEmits(['codeEntered', 'hide'])
const store = useStore()

const codeInput = ref(null)

defineProps({
  allowForBackup: {
    type: Boolean,
    default: false
  }
})

let bvModal = null
const mode = ref('code')

onMounted(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.ctx?._bv__modal
})

const onShow = () => {
  mode.value = 'code'
  codeInput.value?.focus()
}

const codeInputHandler = async (val) => {
  const limit = mode.value === 'backup' ? 8 : 6
  store.commit('cleanValidationErrors')
  if(val.length < limit) return
  emit('codeEntered', val)
  bvModal.hide('two-factor-code-input-modal')
}
</script>

<style scoped lang="scss">

</style>
